export default __webpack_public_path__ + "static/media/STRIP-Logo1.3bbdf606.png";